import styled from '@emotion/styled';
import {
  Checkbox,
  TableHead as MUITableHead,
  TableRow as MUITableRow,
} from '@mui/material';
import tw from 'twin.macro';

import { TableHeadCell } from './TableHeadCell';

const StyledCheckbox = styled(Checkbox)`
  ${tw`!p-0 w-6 h-6 text-base-600`}

  .MuiSvgIcon-root {
    ${tw`w-[24px] h-[24px]`}
  }

  &.Mui-checked {
    ${tw`text-brand-500`}
  }
`;

const getCells = isManager => [
  ...(isManager ? [{ id: 'callerName', label: 'Caller Name' }] : []),
  { id: 'bookedOn', label: 'Booked On' },
  { id: 'scheduled', label: 'Scheduled' },
  { id: 'rescheduled', label: 'Rescheduled' },
  { id: 'apptType', label: 'Appt Type' },
  { id: 'companyName', label: 'Company Name' },
  { id: 'contactName', label: 'Contact Name' },
  { id: 'contactTitle', label: 'Contact Title' },
  { id: 'status', label: 'Status' },
];

export const TableHead = ({
  isManager,
  isSomeRowsSelected,
  isAllRowsSelected,
  onSelectAllRows,
}) => {
  return (
    <MUITableHead>
      <MUITableRow>
        {isManager && (
          <TableHeadCell>
            <StyledCheckbox
              indeterminate={isSomeRowsSelected}
              checked={isAllRowsSelected}
              onChange={onSelectAllRows}
              disableRipple
            />
          </TableHeadCell>
        )}
        {getCells(isManager).map(cell => (
          <TableHeadCell key={cell.id} align={cell.align}>
            {cell.label}
          </TableHeadCell>
        ))}
        <TableHeadCell />
      </MUITableRow>
    </MUITableHead>
  );
};
